import { differenceInCalendarDays } from 'date-fns';

export const calculateDaysFromToday = (backDate: Date): number => {
  return Math.max(0, differenceInCalendarDays(new Date(), backDate));
};
